<div *ngIf="toastService.data"
     [ngClass]="{ success: toastService.data && toastService.data.type === 1 }"
     (mouseenter)="stopCountDown()"
     (mouseleave)="countDown()"
     [@openClose]="toastService.data && toastService.data.show ? 'open' : 'closed'">
  <div>
    <div class="toast_title">
      {{ toastService.data.title | translate }}
    </div>
    <div class="toast_text">
      {{ toastService.data.content | translate }}
    </div>
  </div>
  <mat-icon (click)="closeToast()">close</mat-icon>
</div>
